import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-contact-support',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, DialogModule],
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss'],
})
export class ContactSupportComponent {
  supportPhone = '+1-209-498-7321';
  supportEmail = 'support@anystore.app';
  dialogRef = inject(DynamicDialogRef);
  emailForm = {
    name: '',
    email: '',
    subject: '',
    message: ''
  };
  
  isSubmitting = false;
  submitSuccess = false;
  submitError = '';

  callSupport() {
    window.location.href = `tel:${this.supportPhone}`;
  }

  chatSupport() {
    // open native messageing app
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "open-messaging-app", data: {phone: this.supportPhone}}));
  }

  async submitEmailForm() {
    if (!this.validateForm()) {
      return;
    }

    this.isSubmitting = true;
    this.submitError = '';

    try {
      // Simulate API call - replace with actual email service
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      this.submitSuccess = true;
      this.resetForm();
      
      // Reset success message after 3 seconds
      setTimeout(() => {
        this.submitSuccess = false;
      }, 3000);
      
    } catch {
      this.submitError = 'Failed to send message. Please try again.';
    } finally {
      this.isSubmitting = false;
    }
  }

  private validateForm(): boolean {
    if (!this.emailForm.name.trim()) {
      this.submitError = 'Please enter your name.';
      return false;
    }
    
    if (!this.emailForm.email.trim()) {
      this.submitError = 'Please enter your email.';
      return false;
    }
    
    if (!this.isValidEmail(this.emailForm.email)) {
      this.submitError = 'Please enter a valid email address.';
      return false;
    }
    
    if (!this.emailForm.subject.trim()) {
      this.submitError = 'Please enter a subject.';
      return false;
    }
    
    if (!this.emailForm.message.trim()) {
      this.submitError = 'Please enter your message.';
      return false;
    }
    
    if (this.emailForm.message.length < 10) {
      this.submitError = 'Message must be at least 10 characters long.';
      return false;
    }
    
    return true;
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  private resetForm() {
    this.emailForm = {
      name: '',
      email: '',
      subject: '',
      message: ''
    };
  }

  clearError() {
    this.submitError = '';
  }

  closeDialog() {
    this.dialogRef.close(true);
  }
} 